module.exports = __webpack_public_path__ + "static/media/NoIcon.ddeccf0c.svg";